import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from "react-router-dom";
import { store, persistor } from "store/store";
import ScrollToTop from "./ScrollToTop";
import App from "./App";


import "react-toastify/dist/ReactToastify.css";
// import "react-phone-input-2/lib/style.css";

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
        <ScrollToTop />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
